import React, { useState, useEffect } from "react";
import Input from "components/CustomInput/CustomInput";
import { ReactComponent as RightArrow } from "assets/img/icons/rightArrow.svg";
import CustomButton from "components/CustomButton";

function SearchInputField({
  handleSearched,
  className,
  value = "",
  placeholder = "Search Here",
  inputEl,
  Icon = RightArrow,
}) {
  const [searchValue, setSearchValue] = useState(value);

  useEffect(() => {
    if (value === "") {
      setSearchValue("");
    }
  }, [value]);

  const handleChange = (val) => {
    let newVal = val.replace(/  +/g, " ");

    if (val !== " ") {
      setSearchValue(newVal);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key !== "Enter") {
      return;
    }

    if (!searchValue) return;

    handleSearched(searchValue);
  };

  const searchedValue = (value) => {
    handleSearched(value);
  };

  return (
    <div className={className}>
      <div className="searchField">
        <Input
          inputRef={inputEl}
          style={{ width: "100%" }}
          formGroup={false}
          inputClass="full_w searchInput"
          inputProps={{
            id: "search",
            autoFocus: true,
            onKeyDown: handleKeyDown,
            value: searchValue,
            onChange: (e) => handleChange(e.target.value),
            type: "text",
            placeholder: placeholder,
          }}
        />
        <CustomButton
          type="button"
          disabled={!searchValue && true}
          onClick={() => searchedValue(searchValue)}
          buttonStyle={{ width: "unset" }}
          buttonClass=" light-gray-btn"
        >
          <Icon className="searchButton" />
        </CustomButton>
      </div>
    </div>
  );
}

export default SearchInputField;
